import { useContext, useEffect } from 'react';
import OrgContext from '../../contexts/OrgContext';
import { Helmet } from 'react-helmet';
import { Segment } from "semantic-ui-react";
import BreadCrumbs from "./BreadCrumbs";
import Dashboard from './Dashboard';
import OldDashboard from '../Dashboard';
import UserContext from '../../contexts/UserContext';
 

const Org = () => {

    const userContext = useContext(UserContext)

    if(userContext.userInfo){
        if(userContext.userInfo.dashboard === "new"){
            return <div>
                <OrgContext.Provider>
                    <Helmet><title>Organization</title></Helmet>
                    <Segment>
                        <Segment>
                            <BreadCrumbs />
                        </Segment>
                        <Dashboard />
                    </Segment>
                </OrgContext.Provider>
            </div>
        } else {
            return <OldDashboard />
        }

    }
    return <></>
}

export default Org